import Button from 'components/ui/button';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { updateUserProfile } from 'services/profile.service';
import { useAuth } from 'context/AuthContext';
import { getAllNotifications } from 'services/notifications.service';
import { readOncePerSession, SESSION_KEYS, setSessionValue } from 'utils/session-reads';

export default function Notifications() {
  const { user, userInfo, refreshUser } = useAuth();

  const [modalData, setModalData] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const userId = user?._id;
  const hasUserInfo = !!userInfo;
  const cadMissao = userInfo?.cad_missao;
  const lastMessage = user?.extra?.lastMessage;

  async function closeNotification() {
    if (!userId) return;

    setLoading(true);
    const payload = [...modalData];

    await updateUserProfile({
      _id: userId,
      extra: {
        ...user?.extra,
        lastMessage: modalData[0].created,
      },
    });

    payload.shift();
    // A lista que sobrou é o novo valor da sessão: fechada, a notificação não volta (DCE-38).
    setSessionValue(SESSION_KEYS.notifications(userId), payload);
    setModalData(payload);
    setLoading(false);

    refreshUser();
  }

  // Lida 1 vez por sessão por player (DCE-37); uma nova referência de `user` não relê (DCE-28).
  useEffect(() => {
    if (!userId || !hasUserInfo) return;

    let active = true;

    readOncePerSession(SESSION_KEYS.notifications(userId), () =>
      getAllNotifications(cadMissao as number, lastMessage),
    )
      .then(data => {
        if (active) setModalData(data);
      })
      .catch(error => console.error('Erro ao carregar notificações:', error));

    return () => {
      active = false;
    };
  }, [userId, hasUserInfo, cadMissao, lastMessage]);

  if (!modalData || modalData?.length < 1 || loading) return null;

  const item = modalData[0];

  return (
    <div className="modal-notification absolute top-10 left-[10%] border-2 border-solid border-electric-blue bg-oxford-blue rounded-lg p-7 w-[90vw] lg:w-[471px]">
      <Button
        color="primary"
        className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
        onClick={() => closeNotification()}
      >
        <IoIosClose color="white" size={30} />
      </Button>

      {item?.text && <div className="relative w-full" dangerouslySetInnerHTML={{ __html: item?.text }}></div>}
    </div>
  );
}
